module.exports = __webpack_public_path__ + "media/images/question-sidebar-icon-87277b378f774076cee49de0bb13f510.svg";